<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <p class="label">选择车辆</p>
        <selecAlotCCar
          ref="selecAlotCCar"
          @deviceIdList="searchItem.deviceIdList = $event"
        ></selecAlotCCar>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button @click="openDetail(row)">查看明细</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <ly-map ref="lymap"></ly-map>
    <Modal v-model="openDetailForm" title="评分明细" footer-hide fullscreen>
      <reportAssessDetail ref="detail"></reportAssessDetail>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import reportAssessDetail from "./reportAssessDetail.vue";
export default {
  components: { reportAssessDetail },
  data() {
    return {
      openDetailForm:false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "姓名",
          key: "userName",
        },
        {
          title: "评分",
          key: "grade",
        },
        {
          title: "单位名称",
          key: "groupName",
        },
        {
          title: "扣分",
          key: "score",
        },
        {
          title: "开始时间",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime));
          },
        },
        {
          title: "结束时间",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime));
          },
        },
        {
          title: "操作",
          slot: "detail",
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.report + "/assess/sum",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          console.log(data);
          this.tableData = data;
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.deviceIdList,
        },
        {
          name: "startTime",
          value: this.timeObj.start,
        },
        {
          name: "endTime",
          value: this.timeObj.end,
        },
      ];
      this.utils.exportData(axios.report + "/countDaily/export", params);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    openMap(v) {
      var obj = {
        address: v.stayAdd,
        lng: v.stayX,
        lat: v.stayY,
      };
      this.$refs.lymap.open(obj);
    },
    openDetail(row){
      this.openDetailForm=true;
      this.$refs.detail.reachData(row);
    }
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/report/reportAssess.vue